
import React from 'react';
import CustomerInformation, { CustomerFormValues } from './CustomerInformation';
import ShippingInformation, { ShippingFormValues } from './ShippingInformation';
import PaymentMethod from './PaymentMethod';
import { ShippingOptionType } from './ShippingInformation';
import { PaymentMethodType } from './PaymentMethod';

interface DesktopCheckoutLayoutProps {
  shippingOptions: ShippingOptionType[];
  selectedShipping: string;
  setShipping: (id: string) => void;
  paymentMethods: PaymentMethodType[];
  selectedPayment: string;
  setPaymentMethod: (id: string) => void;
  currency: string;
  handleCustomerInfoSubmit: (data: CustomerFormValues) => void;
  handleShippingInfoSubmit: (data: ShippingFormValues) => void;
}

const DesktopCheckoutLayout: React.FC<DesktopCheckoutLayoutProps> = ({
  shippingOptions,
  selectedShipping,
  setShipping,
  paymentMethods,
  selectedPayment,
  setPaymentMethod,
  currency,
  handleCustomerInfoSubmit,
  handleShippingInfoSubmit
}) => {
  return (
    <div className="lg:col-span-2 space-y-8">
      <CustomerInformation onSubmit={handleCustomerInfoSubmit} />
      <ShippingInformation 
        shippingOptions={shippingOptions} 
        selectedShipping={selectedShipping} 
        setShipping={setShipping} 
        currency={currency}
        onSubmit={handleShippingInfoSubmit}
      />
      <PaymentMethod 
        paymentMethods={paymentMethods} 
        selectedPayment={selectedPayment} 
        setPaymentMethod={setPaymentMethod} 
      />
    </div>
  );
};

export default DesktopCheckoutLayout;
